export default "__VITE_ASSET__CSx9rL3X__"